// extracted by mini-css-extract-plugin
export default {"alignCard":"Align_alignCard__JzqB4","title":"Align_title__QSttp","grid":"Align_grid__xm-ng","button":"Align_button__txFNB","active":"Align_active__m1P1K"};